
  import { defineComponent, PropType } from 'vue';

  import ExportButtons from '@/common/components/redesigned/ExportButtons.vue';
  import { downloadPDF } from '@/common/utils/fileExport';

  import { TDashboardRegionFilterFullFilter } from '@/modules/ves/types/regionDashboards';
  import { moveDashboardsChartsToTopLevel } from '@/modules/ves/utils/dashboardsCharts';

  import apiDashboards from '../../../api/dashboardsVES';

  export default defineComponent({
    name: 'RegionDashboardsExportButtons',
    components: {
      ExportButtons,
    },
    props: {
      filter: {
        type: Object as PropType<TDashboardRegionFilterFullFilter>,
        required: false,
      },
      plannedEventsRegionRfIds: {
        type: Array as PropType<number[]>,
        default: () => [],
      },
    },
    data(): { isLoading: boolean } {
      return {
        isLoading: false,
      };
    },
    methods: {
      async downloadPDF() {
        this.isLoading = true;
        await downloadPDF({
          clonedElementClassName: 'region-dashboards-ves__export-pdf',
          pagebreakMode: 'table-friendly',
          fileName: 'Мониторинг_реализации_документов_по_ВЭС',
          clonedNodeFormatter: moveDashboardsChartsToTopLevel,
        });
        this.isLoading = false;
      },
      async downloadPptx() {
        this.isLoading = true;
        try {
          await apiDashboards.exportPptx('exportregion', {
            ...this.filter,
            regionRfIds: this.plannedEventsRegionRfIds,
          });
        } finally {
          this.isLoading = false;
        }
      },
    },
  });
